import './CallTo.scss';

const CallTo = ({ phone, children, addClass }) => {

    return (
        <a href={`tel:${phone}`} className={addClass}>{children}</a>
    );
}

export default CallTo;